import { Modal } from '@/modules/modals';

import { useReviewPrizepoolStore } from '../../services/store';
import { ReviewPrizepoolSteps } from '../ReviewPrizepoolSteps';

export const ReviewPrizepoolModal = () => {
    const open = useReviewPrizepoolStore(state => state.open);

    return (
        <Modal open={open} width={520}>
            <ReviewPrizepoolSteps />
        </Modal>
    );
};
